/**
 * Print Service
 * Serviço centralizado para impressão de pedidos
 * Utiliza localStorage para transferir dados e abre a rota /print-order em nova janela
 */
import { showError, showWarning } from "@/store/errorStore";
import { getCompanyName } from "@/lib/company";

/**
 * Imprime o recibo de um pedido
 * @param {Object} order - Objeto do pedido a ser impresso
 * @param {Object} order.products - Array de produtos do pedido
 * @returns {Promise<void>}
 */
export const printOrder = async (order) => {
  try {
    // Valida se o pedido tem produtos
    if (!order || !order.products || order.products.length === 0) {
      showWarning("Pedido incompleto. Não é possível imprimir.");
      return;
    }

    // Armazena o pedido no localStorage, com o nome da empresa: a janela de
    // impressão imprime antes de o AuthProvider dela carregar a empresa
    localStorage.setItem(
      "printOrder",
      JSON.stringify({ ...order, company_name: getCompanyName(order) })
    );

    // Abre nova janela com a página de impressão
    const printWindow = window.open(
      "/print-order",
      "_blank",
      "width=400,height=600,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes"
    );

    // Verifica se a janela foi aberta (bloqueador de popup)
    if (!printWindow) {
      showWarning(
        "Não foi possível abrir a janela de impressão. Verifique se o bloqueador de popup está ativado."
      );
    }
  } catch (error) {
    console.error("Erro ao preparar impressão:", error);
    showError("Erro ao gerar o recibo.");
  }
};

/**
 * Exportação default para compatibilidade
 */
export default {
  printOrder,
};
